export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref13110.f397ad02.jpg";